import { Component, Inject, ViewContainerRef } from '@angular/core';
import { AppService } from '../../../app.service';
import { CustomerList, JobsiteList, ChangeImplementJobsiteData } from './change-implement-jobsite-modal';
import { ChangeImplementJobsiteModalService } from './change-implement-jobsite-modal.service';
import { OrdinalDateAdapter, ORD_DATE_FORMATS, OrdinalDateParse } from '../adapters/ordinal-date-adapter';
import { GETInventoryService } from '../services/inventory.service';
import { ErrorCode, ErrorMessages } from '../entities/global/error-codes';
import { NotificationsService } from 'angular2-notifications';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'change-implement-jobsite-modal',
    templateUrl: './change-implement-jobsite-modal.component.html',
    providers: [
        {
            provide: DateAdapter, useClass: OrdinalDateAdapter
        },
        {
            provide: MAT_DATE_FORMATS, useValue: ORD_DATE_FORMATS
        }
    ]
})

export class ChangeImplementJobsiteModalComponent {
    customers: CustomerList[];
    jobsites: JobsiteList[];
    cost: number;
    eventDate: Date;
    comment: string;
    ord: OrdinalDateParse = new OrdinalDateParse();

    minDate: Date = new Date();
    maxDate: Date = new Date();

    changeData: ChangeImplementJobsiteData;
    savingChanges: boolean = false;

    // Tooltips
    ttDate: string = "Click here to select a date.";
    ttComment: string = "You may enter a maximum of 256 characters.";
    
    constructor(private _appService: AppService, public dialogRef: MatDialogRef<ChangeImplementJobsiteModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any, private _moduleService: ChangeImplementJobsiteModalService,
        public toastr: NotificationsService, vcr: ViewContainerRef, public _inventoryService: GETInventoryService) {
    
    }
    ngOnInit() {
        this.changeData = new ChangeImplementJobsiteData();

        this.eventDate = new Date();
        this.changeData.date = this.eventDate;

        if (this.data != null) {
            if (this.data.implementId) {
                this.changeData.implementId = this.data.implementId;

                this._inventoryService.returnMinDateForImplementEvent(this.data.implementId)
                    .subscribe(response => {
                        if (response != "") {
                            try {
                                this.minDate = new Date(response);
                            }
                            catch (ex) {
                                this.minDate = new Date();
                            }
                        }
                    });
            }
        }
        
        this._moduleService.returnCustomersByUserId().subscribe(response => {
            this.customers = response;
        }, error => { console.log(error); });
    }
    onCloseClick(): void {
        this.dialogRef.close();
    }
    saveChanges(): void {
        if (this.savingChanges) {
            return;
        }

        let validation = this.validateData();
        this.savingChanges = true;

        if (validation == ErrorCode.VALIDATION_PASSED) {
            this._moduleService.saveImplementJobsiteChange(this.changeData).subscribe(response => {
                this.dialogRef.close();
            }, error => { console.log(error); });
        }
        else if (validation == ErrorCode.ERROR_NEGATIVE_COST) {
            this.toastr.error(ErrorMessages.ERROR_NEGATIVE_COST);
            this.savingChanges = false;
        }
        else {
            this.toastr.error(ErrorMessages.ERROR_MISSING_FIELDS);
            this.savingChanges = false;
        }
    }
    validateData(): number {
        var returnCode = ErrorCode.ERROR_MISSING_FIELDS;

        if (this.changeData.customerId
            && this.changeData.jobsiteId
            && this.changeData.cost
            && this.changeData.date
            && this.changeData.comment)
        {
            if (this.changeData.cost < 0) {
                returnCode =  ErrorCode.ERROR_NEGATIVE_COST;
            }
            else {
                returnCode =  ErrorCode.VALIDATION_PASSED;
            }
        }

        return returnCode;
    }

    // Customer
    customerSelected(customerId): void {
        this.changeData.customerId = customerId;
        this._moduleService.returnJobsitesByCustomerId(customerId).subscribe(response => {
            this.jobsites = response;
        }, error => { console.log(error); });
    }

    // Jobsite
    jobsiteSelected(jobsiteId): void {
        this.changeData.jobsiteId = jobsiteId;
    }

    // Cost
    costChanged(): void {
        this.changeData.cost = this.cost;
    }

    // Date
    dateChanged(): void {
        this.changeData.date = this.eventDate;
        this.ord.formatDateOrdinal((this.eventDate.toString())
            .split(' ')
            .slice(1)
            .join(' '), false);
    }

    // Comment
    commentChanged(): void {
        this.changeData.comment = this.comment;
    }
}
